module.exports = __webpack_public_path__ + "public/img/dianshang.61c26aad.png";